<app-error-detail-table-record-template [error]="error" (errorTypeUpdated)="updateErrorType($event)"
                           [loadingErrorData]="isLoading" (errorSolved)="solveError()" [isSolvingError]="isSolving">
    <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.message"
                           [content]="error!.message"/>
    <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.stackTrace"
                           [content]="error!.stackTrace ?? 'error.stackTrace.unknown' | translate "/>
</app-error-detail-table-record-template>
